// @ts-strict
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMUrlInfoBuilderService } from '@services/lm-url-info-builder.service';
import { LMFormComponent } from '@app/components';
// import { LMBusyIndicatorService, LMFormatUtilService } from '@app/services';
// import { LMMenuLinkBoxService } from '@services/lm-menu-link-box.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector:    '[lm-page-pane-menu-component]',
  templateUrl: './lm-page-pane-menu.component.html',
  styleUrls: [ './lm-page-pane-menu.component.scss' ]
})
export class LMPagePaneMenuComponent implements OnInit {
  @Input() panel!: LMPagePanelSpec;
  @Input() set messageRuleView(messageRuleView: LMDataView) { // optional if used in a page panel
    this.m_messageRuleView = messageRuleView;
  }

  @Output() panelContentDisplayed = new EventEmitter<LMContentDisplayedEvent>();

  // @ViewChild('menuFormDialog') placeholder: ViewContainerRef | undefined;

  public m_messageRuleView?: LMDataView;
  public formUrlInfo!: LMFormUrlInfo;
  public formSpec!: LMFormSpec;

  // public isMenuLinkBox = false;
  // public links: Array<LinkInfo> = [];
  // public panelTitle!: string;

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    // private lmBusyIndicatorService: LMBusyIndicatorService,
    // private lmFormatUtilService: LMFormatUtilService,
    // private lmMenuLinkBoxService: LMMenuLinkBoxService,
  ) {}

  ngOnInit() {
    if (!this.panel) {
      throw 'LMPagePanelSpec is required before initializing LMPagePaneMenuComponent';
    }
    if (!this.panel.pane?.menuPanelLayout) {
      throw 'LMPagePaneSpec must have a pane.menuPanelLayout';
    }

    const menuFormPanelId = this.buildMenuPanelFormId();
    const automationId = this.buildAutomationId();

    // if (this.panel.pane?.paneType === 'MenuLinkBoxPanel') {
    //   this.isMenuLinkBox = true;
    //   if (this.panel?.panelTitle)
    //     this.panelTitle = this.lmFormatUtilService.formatMessageRule(this.panel.panelTitle, this.m_messageRuleView);
    //   this.links = this.lmMenuLinkBoxService.buildLinkMenuSpec(this.panel.pane.menuPanelLayout, this.m_messageRuleView as LMDataView);
    //   this.lmBusyIndicatorService.hideBusyIndicator();
    // } else {
      this.formSpec = {
        automationId: automationId || menuFormPanelId,
        formElementId: menuFormPanelId,
        busFormSpec: this.buildBusFormSpec(),
        busClassSpec: this.buildBusClassSpec(),
        resourceId: menuFormPanelId,
      };
      this.formUrlInfo = this.lmUrlInfoBuilderService.getFormUrlInfoFromFormSpec(this.formSpec);
    // }
  }

  /**
   * what's the point of this since lm-page.component never does anything with it.
   * @param form
   */
  onFormRendered(form: LMFormComponent) {
    const event: LMContentDisplayedEvent = { args: form };
    this.panelContentDisplayed.emit(event);
  }

  buildBusFormSpec(): LMBusFormSpec {
    const menuPanelLayout = this.panel.pane?.menuPanelLayout;
    if (!menuPanelLayout) {
      throw 'LMPagePaneMenuComponent: pane.menuPanelLayout is undefined';
    }

    const busFormLayoutSpec: LMBusFormLayoutSpec = {
      layout: menuPanelLayout
    };

    const messageRule: LMMessageRule = {
      resourceValue: '',
    };

    return {
      busFormLayoutSpec,
      name:                     '',
      fields:                   {},
      title:                    messageRule,
      formType:                 'Menu',
      effectiveDateField:       {},
      effectiveDateFieldId:     '',
      reasonCodeFieldId:        '',
      actionCommentFieldId:     '',
      effectiveThroughFieldId:  '',
      correctionCommentFieldId: '',
      openActionRestricted:     false,
      implementsDashBoardView:  false,
    };
  }

  buildBusClassSpec(): LMBusClassSpec {

    return {
      actions:                [],
      actionSpec:             {},
      implAuditing:           false,
      implEffectiveDated:     false,
      isBusClass:             false,
      isBusTask:              false,
      name:                   'menuPanel',
      implementsOrgChartView: false,
    };
  }

  // onLinkClicked(link: LinkInfo): void {
  //   this.lmMenuLinkBoxService.runMenuLinkBoxAction(link, this.placeholder as ViewContainerRef);
  // }

  private buildMenuPanelFormId() {
    // const id = this.panel.id || '';
    // return this.lmUniqueIdService.uniqueId([ id, 'MenuPanel' ]);

    // leaving this as is so that anyone using id=MenuPanel for automation can still sort of function.
    return this.lmUniqueIdService.uniqueId([ 'MenuPanel' ]);
  }

  private buildAutomationId() {
    if (!this.panel.automationId) {
      return null;
    }

    return this.panel.automationId + '-MenuPanel';
  }
}
